import React, { useCallback } from 'react'
import { Modal } from 'react-native'
import styled from 'styled-components/native'
import IntakeReplyForm from 'APP/Components/Intake/IntakeReplyForm'
import { isWeb } from 'APP/Helpers/checkPlatform'
import type { PromptAddressItemProps } from './types'

interface WrapperProps {
  children: React.ReactNode
}

interface ConditionalOverlayFormProps {
  conditionalOverlayFormData: PromptAddressItemProps
  sendAnswer: (answer: unknown) => void
  onClose: () => void
}

const WebOverlay = styled.View`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
`

const ReplyForm: React.FC<React.ComponentProps<typeof IntakeReplyForm>> = (props) => (
  <IntakeReplyForm {...props} />
)

const OverlayReplyForm = styled(ReplyForm)`
  flex: 1;
  margin-top: ${({ theme }) => theme.metrics.baseMargin}px;
  margin-bottom: ${({ theme }) => theme.metrics.baseMargin}px;
`

const Wrapper: React.FC<WrapperProps> = ({ children }) =>
  isWeb() ? (
    <WebOverlay testID="webview-wrapper">{children}</WebOverlay>
  ) : (
    <Modal statusBarTranslucent visible transparent animationType="none" testID="modal-wrapper">
      {children}
    </Modal>
  )

export const ConditionalOverlayForm: React.FC<ConditionalOverlayFormProps> = ({
  conditionalOverlayFormData,
  sendAnswer,
  onClose,
}) => {
  const sendAdditionalAnswer = useCallback(
    (answer: unknown) => {
      sendAnswer(answer)
    },
    [sendAnswer]
  )
  return (
    <Wrapper>
      <OverlayReplyForm
        inline={false}
        onClose={onClose}
        sendAnswer={sendAdditionalAnswer}
        {...conditionalOverlayFormData}
      />
    </Wrapper>
  )
}
